interface User {
	userId: string;
	name?: string;
	email?: string;
}

interface AuthData {
	user: User;
	token?: string;
}

export const getUserFromPersistedAuth = (): User | null => {
	try {
		const rootPersistedData = localStorage.getItem("persist:root");
		if (!rootPersistedData) return null;

		const parsedRoot = JSON.parse(rootPersistedData);
		const authData: AuthData = JSON.parse(parsedRoot.auth || "{}");

		return authData.user || null;
	} catch (error) {
		console.error("Error parsing user data from localStorage:", error);
		return null;
	}
};
